import React from "react";
import "./Styles/pageHeader.css"
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export default function PageHeader({title}) {
    return (
        <>
            <div className="page-header-container">
                <a href="/"><ArrowBackIcon/> Retourner à l'accueil</a>
                <h1>{title}</h1>
            </div>
        </>
    )
}